
import type { Action } from './types';

export const SWITCH_LOCALE = 'SWITCH_LOCALE';
export const SET_CONFIG = 'SET_CONFIG';
export const CACHE_KIOSK_PUBLICATIONS = 'CACHE_KIOSK_PUBLICATIONS';

export function switchLocale(locale: string='en'):Action {
  return {
    type: SWITCH_LOCALE,
    locale: locale,
  };
}
export function setConfig(config):Action {
  return {
    type: SET_CONFIG,
    config: config,
  };
}

export function cacheKioskPublications(kioskPublications):Action {

  return {
    type: CACHE_KIOSK_PUBLICATIONS,
    kioskPublications: kioskPublications,
  };
}



// WEBPACK FOOTER //
// ./src/actions/appConfig.js